// TeamMembers.js
import React, { useEffect, useState } from 'react';
import TeamMember from './TeamMember';
import './TeamMembers.css';
import {teamData} from './teamData';
import Seo from '../components/Seo';
import { useI18n } from '../i18n/I18nContext';

const TeamMembers = () => {
  const { t } = useI18n();
  const [teamMembers, setTeamMembers] = useState([]);
  //const [error, setError] = useState(null);

  //get team data from teamData.js
  useEffect(() => {
    setTeamMembers(teamData);
  }, []);

  return (
    <div className="team-members">
      <Seo
        title={t('team.seoTitle')}
        description={t('team.seoDescription')}
        path="/team"
      />
      <h1 className="team-title">{t('team.title')}</h1>
      {teamMembers.map((member) => (
        <TeamMember key={member.id} {...member} />
      ))}
    </div>
  );
};

export default TeamMembers;
